// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { lazy } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';
import type { ConnectIssueModal as ConnectIssueModalType } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ConnectModal = lazy<typeof ConnectIssueModalType>(() =>
	import(/* webpackChunkName: "async-connect-issue-modal" */ './index').then(
		({ ConnectIssueModal }) => ConnectIssueModal,
	),
);

export const AsyncConnectModal = (
	props: JSX.LibraryManagedAttributes<
		typeof ConnectIssueModalType,
		ComponentProps<typeof ConnectIssueModalType>
	>,
) => (
	<Placeholder name="connect-issue-modal" fallback={null}>
		<ConnectModal {...props} />
	</Placeholder>
);
